<template>
    <button
        :aria-controls="controls"
        :aria-expanded="expanded.toString()"
        type="button"
        @click="expanded = !expanded"
    >
        <slot />
    </button>
</template>

<script>
import bus from '@/js/util/disclosure';

export default {
    name: 'DisclosureButton',
    props: {
        controls: {
            type: String,
            required: true,
        },
        initiallyExpanded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            expanded: this.initiallyExpanded,
        };
    },
    watch: {
        expanded() {
            bus.$emit('toggle', {
                controls: this.controls,
                expanded: this.expanded,
            });
        },
    },
    created() {
        bus.$on('created:container', this.createdContainer);
    },
    methods: {
        createdContainer(id) {
            bus.$emit('toggle', {
                controls: id,
                expanded: this.expanded,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/disclosure/DisclosureButton.vue